import {Image} from '@coolcolduk/ui-image';
import {Grid, Typography} from '@mui/material';

export default function NotAuthenticatedPage() {
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Typography variant="h1" sx={{pt: 2, pb: 2}}>
        Please login 😉
      </Typography>
      <Image src="/error.jpg" sx={{'& > img': {borderRadius: '16px'}}} width="60%" />
    </Grid>
  );
}
